import React, { useState } from 'react';

const BarChart = ({ data, title, xKey, yKey, color = 'var(--primary)', height = 300 }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const containerStyle = {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    padding: '20px'
  };

  const titleStyle = {
    fontSize: '16px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '20px'
  };

  const chartStyle = {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    gap: '8px',
    height: `${height}px`,
    padding: '10px 0'
  };

  const chartData = data || [];
  const maxValue = chartData.length > 0 ? Math.max(...chartData.map(item => item[yKey] || 0), 1) : 1;

  return (
    <div style={containerStyle}>
      {title && <div style={titleStyle}>{title}</div>}
      <div style={chartStyle}>
        {chartData.length === 0 ? (
          <div style={{ color: 'var(--text-secondary)', fontSize: '14px', width: '100%', textAlign: 'center', alignSelf: 'center', margin: 'auto' }}>
            No data available for the selected period
          </div>
        ) : (
          chartData.map((item, index) => {
            const barHeight = (item[yKey] / maxValue) * 100;
            const isHovered = hoveredIndex === index;

            const barContainerStyle = {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flex: 1,
              gap: '8px',
              position: 'relative',
              height: '100%'
            };

            const barStyle = {
              width: '100%',
              maxWidth: '60px',
              height: `${barHeight}%`,
              background: color,
              borderRadius: '8px 8px 0 0',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              opacity: isHovered ? 1 : 0.8,
              transform: isHovered ? 'scaleY(1.05)' : 'scaleY(1)',
              transformOrigin: 'bottom'
            };

            const labelStyle = {
              fontSize: '12px',
              color: 'var(--text-secondary)',
              fontWeight: '600',
              textAlign: 'center'
            };

            const valueStyle = {
              position: 'absolute',
              top: '-25px',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '12px',
              fontWeight: '700',
              color: 'var(--text-primary)',
              background: 'var(--surface)',
              padding: '4px 8px',
              borderRadius: '4px',
              border: '1px solid var(--border)',
              opacity: isHovered ? 1 : 0,
              transition: 'opacity 0.3s ease',
              whiteSpace: 'nowrap'
            };

            return (
              <div
                key={index}
                style={barContainerStyle}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', flex: 1 }}>
                  <div style={barStyle} />
                  <div style={valueStyle}>{item[yKey]}</div>
                </div>
                <div style={labelStyle}>{item[xKey]}</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default BarChart;